import { Provider } from '@angular/core';
import {
  IRestrictedNavigationServiceConfig,
  RESTRICTED_NAVIGATION_SERVICE_CONFIG,
} from '@lib/interfaces/restricted-navigation';
import { RoutesCommon } from './routes.config';

const config: IRestrictedNavigationServiceConfig = {
  browserBackOrForward: {
    [RoutesCommon.SERVICE_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
    [RoutesCommon.SYSTEM_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
    [RoutesCommon.SESSION_TIMEOUT_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
    [RoutesCommon.BROWSER_BACK_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
  },
  directAccessOrReload: {
    [RoutesCommon.SERVICE_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
    [RoutesCommon.SYSTEM_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
    [RoutesCommon.SESSION_TIMEOUT_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
    [RoutesCommon.BROWSER_BACK_ERROR]: RoutesCommon.BROWSER_BACK_ERROR,
  },
};

/**
 *
 * @description provider for `AppModule`
 * @export
 * @type {Provider}
 */
export const RESTRICTED_NAVIGATION_SERVICE_CONFIG_PROVIDER: Provider = {
  provide: RESTRICTED_NAVIGATION_SERVICE_CONFIG,
  useValue: config,
};
